module.exports = __webpack_public_path__ + "static/media/swirly-divider-top.58ca5f23.svg";